import { Text, TextProps } from "@chakra-ui/react";

export default function Logo(props: TextProps) {
  return (
    <Text fontSize="lg" fontWeight="bold" color="teal.400" {...props}>
      لوحة التحكم
    </Text>
  );
}
